/*
 * @Author: Src
 * @Date: 2024-12-20 09:03:27
 * @LastEditTime: 2025-09-22 19:27:52
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/services/shop.service.ts
 * @Description: 头部注释配置模板
 */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';
import { freeze } from '@/common/utils';

interface City {
    code: string; // 城市编号
    depth: number;
    id: number; // 城市id
    name: string;
    pid?: number;
    pinyin: string;
    pinyin2: string;
    province?: City;
}

export interface Kalist {
    kaId: number;
    kaName: string;
}




@injectable()
export default class ShopService {
    @inject(HttpClient)
    protected http!: HttpClient;

    async getShopInfo() {
        try {
            const result = (await this.http.get(`kaShopInfo/check`)) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

    async getPoi(regionId: any, keywords: any) {
        try {
            const result = (await this.http.get(`region/${regionId}/poi/${keywords}`)) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

    /**
      * 获取城市里列表
      *
      * @param {boolean} [covered]
      * @return {Promise<City[]>}
      * @memberof BaseService
      */
    async getCityList(payload: {
        covered?: boolean;
        joined?: boolean;
        aggregation?: boolean;
    } = {
            // covered: true,
            joined: true,
            aggregation: true,
        }): Promise<City[]> {
        const query: string[] = [];
        Object.entries(payload).forEach(([key, value]) => {
            query.push(`${key}=${value}`);
        });
        const data: City[] = await this.http.get(`/region?${query.join('&')}`);
        return freeze(data);
    }


    async addShop(payload: any) {
        const result = (await this.http.post(`kaShopInfo/add`, payload)) as any;
        return result;
    }


    async getShopList(params: any) {
        console.log(params, 'payload');
        try {
            const result = await this.http.get(`kaShopInfo/list`, { params }) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

    /**
     * 获取店铺详情
     *
     * @param {any} shopId
     * @return {*} 
     * @memberof ShopService
     */
    async getShopDetail(shopId: any) {
        try {
            const result = (await this.http.get(`kaShopInfo/${shopId}/detail`)) as any;
            return result;
        } catch (error) {
            return null;
        }
    }


    async getPointList(params: any) {
        try {
            const result = (await this.http.get(`online_shop/point/list`, { params })) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

    async getPointAdd(data: any) {
        try {
            const result = (await this.http.post(`online_shop/poi/point/add`, data)) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

}
